import { z } from "zod";
import { publicEndpoint } from "~/lib/api/builder";

export const forgotPassword = publicEndpoint.mutation(
    (json) => ({
        json,
        method: "POST",
        url: "auth/forgot-password",
    }),
    {
        input: z.object({
            email: z.string(),
        }),
        output: z.object({}),
    },
);
